import * as React from "react";

import * as Utils from "../../utils";

import s from "./index.module.scss";
import { Device } from "../../models/Device";
import EnvirotainerState from "../../models/Envirotainer/EnvirotainerState";
import { PT300State } from "../../models/PT300/PT300State";
import State from "../../models/State";
import Popup from "reactjs-popup";
import { AlarmsList, activeAlarmsPopupTrigger, clearedAlarmsPopupTrigger } from "../Alarm/AlarmsList";
import { TLocationProperty } from "../../types";

type PropsType = {
	device?: Device;
	location?: TLocationProperty;
	onClick?: (device: Device) => void;
};

type PopUpSensorType = {
	key: string;
	name: string;
	unit: string;
};

const DeviceMapPopup = ({ device, location, onClick }: PropsType): JSX.Element => {
	const source = location?.dataSource;

	const redirectToVisibilityWidget = (): void => {
		if (device && onClick) {
			onClick(device);
		}
	};

	const getPresent = (): EnvirotainerState | PT300State | State | null | undefined => {
		if (!device?.type) {
			return device?.present;
		}
		switch (device.type.toUpperCase()) {
			case "ENVIROTAINER": {
				return device?.present as EnvirotainerState;
			}
			case "PT300D":
			case "PT300": {
				return device?.present as PT300State;
			}
			default:
				return device?.present as EnvirotainerState;
		}
	};

	const present = getPresent();

	const getPopupFormatInfo = (): PopUpSensorType[] => {
		const sensors: PopUpSensorType[] = [];
		if (device && present) {
			device.getMapAttributesConfig().popupAttributes.map((keyName: string) => {
				const config = device.getAttributesConfig().get(keyName);
				if (config) {
					sensors.push({ key: keyName, name: config["displayName"], unit: config["unit"] });
				}
			});

			return sensors;
		}

		return [];
	};

	return (<>
		{!!device && device.shipment && (
			<div className={s.popup}>
				<div className={s.popup__column}>
					<div className={s.popup__status}>
						<div>
							{device.shipment.masterTrackingNo || device.shipment.id}
						</div>
					</div>

					<a className={s.link} onClick={e => {
						e.preventDefault && e.preventDefault();
						redirectToVisibilityWidget();
					}}>
						{device.getDisplayName()}
					</a>
					{present && getPopupFormatInfo().map(sensor => {
						const { key, name, unit } = sensor;

						return (
							<div className={s.popup__status} key={key}>
								{present[key] && (
									<div>
										<b>{name}: </b>{present[key].value.toFixed(1) + " " + unit}
									</div>
								)}
							</div>);
					})}
					<div className={s.popup__status}>
						{device.shipment?.flight && (
							<div>
								<b>Flight #: </b>{device.shipment?.flight}
							</div>
						)}
					</div>

					<div className={s.popup__status}>
						{device.shipment?.awb && (
							<div>
								<b>AWB: </b>{device.shipment?.awb}
							</div>
						)}
					</div>

					<div className={s.popup__status}>
						<div>
							{location?.epoch ? Utils.time.format(location.epoch, "D MMMM YYYY HH:mm:ss") : ""}
						</div>
					</div>

					<div className={s.popup__source}>
						{source === "flight" && (
							<div>{source}</div>
						)}
					</div>
					{!!device.getActiveAlarms().length && (
						<Popup trigger={activeAlarmsPopupTrigger}
							position="bottom left"
							overlayStyle={{ position: "inherit" }}
							offsetX={-160}
							offsetY={0}
							contentStyle={{ zIndex: 1100 }}
							arrowStyle={{ left: "none", right: "27px" }}
							on={"click"}>
							<AlarmsList alarms={device.getActiveAlarms()} active={true} />
						</Popup>
					)}
					{!!device.getClearedAlarms().length && (
						<Popup trigger={clearedAlarmsPopupTrigger}
							position="bottom left"
							overlayStyle={{ position: "inherit" }}
							offsetX={-180}
							offsetY={0}
							contentStyle={{ zIndex: 1101, width: "280px" }}
							arrowStyle={{ left: "none", right: "27px" }}
							on={"click"}>
							<AlarmsList alarms={device.getClearedAlarms()} />
						</Popup>
					)}
				</div>
			</div>
		)}
	</>
	);
};

export default DeviceMapPopup;
